(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyMouseDetectedCss", [
    "$rootScope",
    "MouseDetectionService",
    function ($rootScope, MouseDetectionService) {
      return {
        restrict: "A",
        scope: false,
        link: function (scope, elem) {
          if (MouseDetectionService.mouseFound) {
            elem.addClass("is-mouse-detected");
            return;
          }

          $rootScope.$on("did-detect-mouse", function () {
            elem.addClass("is-mouse-detected");
          });
        },
      };
    },
  ]);
})(window.angular);
